<template>
  <div style="background: #1f1c1f;">
    <div class="header" >
      <div class="header_content">
        <div class="header_left">
          <div v-if="!hasToken" @click="toLogin('/Register')" class="register-btn">{{$t("auth.register")}}</div>
          <div v-else></div>
        </div>
        
        <div class="header_center">
          <div class="img_c">
            {{$t("q30")}}
          </div>
        </div>
        
        <div class="header_right">
          <div class="location-select">
            <div class="selected-location" @click="toggleLocationMenu">
              <img src="/img/location-icon.png" class="location-icon" alt="location" />
              <span>{{$t("index.region")}}</span>
              <span class="location-arrow" :class="{ 'arrow-open': showLocationMenu }"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="location-menu" :class="{ 'location-menu-open': showLocationMenu }">
      <div class="location-item-container">
        <div class="location-item" 
             v-for="location in locations" 
             :key="location"
             :class="{ 'active': selectedLocation === location }"
             @click="selectLocation(location)">
          {{ location }}
        </div>
      </div>
    </div>
    
    <div class="tu_list">
      <div class="reserve-bg" v-for="item in datalist" :key="item.id">
        <div class="content-bg" @click="toDetail(item.id)">
          <div class="corner_tag">{{$t("index.verified")}}</div>
          <div class="img-container">
            <img :src="item.img_url" class="item_img">
          </div>
          <div class="info_box">
            <div class="name_box">
              <span class="name">{{ item.xuanfei_name }}</span>
              <span class="location">{{$t("index.seoul")}}</span>
            </div>
            <div class="stats">
              <div class="stat_item">
                <img src="/img/neww/icon_views.png" class="icon">
                <span class="stat_num">{{item.chakan}}</span>
              </div>
              <div class="stat_item">
                <img src="/img/neww/icon_love.png" class="icon">
                <span class="stat_num">{{item.dianzan}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id"  @click="toDetail(item.id)">
          <div  class="imgBox">
            <div
              
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <span ><i>{{$t("concubine.high_end")}}</i></span>
          </div>
          <div  style="width: calc(100% - 140px);">
            <div  class="top">
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span >{{$t("index.authentication")}}</span>
              </div>
              <div >
                <div  class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span >{{$t("index.video_authentication")}}</span>
              </div>
              <div
                
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
               {{ item.xuanfei_name }}
              </div>
            </div>
            <div  class="tags">
              <van-tag
        v-for="(tag, index) in item.flagArray"
        :key="index"
        :type="tagTypes[index]"
      >
        {{ tag }}
      </van-tag>
              
            </div>
            <div  style="display: flex; align-items: center;">
              <span
                
                style="font-size: 14px; color: rgb(102, 102, 102);"
                >{{$t("index.toll")}}：</span
              >
              <van-rate v-model="item.number"   color="#ffd21e" size="20px" />
            </div>
            <div
              
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
            {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>
            <div  class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div
      style="
        background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139));
        width: 96%;
        margin: 0px auto 30px;
        border-radius: 8px;
        overflow: hidden;
        padding-bottom: 10px;
      "
    >
      <div
        style="
          color: rgb(255, 232, 105);
          text-align: center;
          padding: 10px 0px;
        "
      >
        當前 1590 人在線匹配
      </div>
      <div class="OnlineMatching">
   
        <div
          :style="{
            transform: `translate(0px, ${translateY}px)`,
            transition: 'transform 1s ease-in',
          }"
          ref="scrollContainer"
        >
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      hotCities: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed:800,
        autoplay:true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows : true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning'],
      selectedLocation: '',
      showLocationMenu: false,
      locations: [], // 从API获取地址列表
      addressList: [] // 存储完整的地址数据（包含id和name）
    };
  },
  computed: {
    // 根据当前语言显示"全部"文本
    allRegionsText() {
      return this.$t('index.all_regions');
    }
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData,"309");
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, "Hot Lottery Data");
        if (res.data && Array.isArray(res.data)) {
          this.hotCities = res.data;
        }
      });
    },
    getAddressList() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        console.log(res, "Address Data");
        if (res.data && Array.isArray(res.data)) {
          // 将二维数组展平为一维数组
          const flatAddresses = res.data.flat();
          
          // 保存完整的地址数据（包含id和name）
          this.addressList = flatAddresses;
          
          // 提取地址名称用于显示，并添加"全部"选项（使用多语言）
          this.locations = [this.allRegionsText, ...flatAddresses.map(addr => addr.name)];
          
          // 设置默认选中项为"全部"
          this.selectedLocation = this.allRegionsText;
        }
      });
    },
    getBanner(data){
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str});
    },
    getNotice(data){
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist(addressId = null) {
      const params = { page: 1 };
      
      // 如果传入了地址ID，则添加到查询参数中
      if (addressId) {
        params.id = addressId;
      }
      
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: params,
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
         console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
         
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
    toggleLocationMenu(event) {
      if (event) {
        event.stopPropagation();
      }
      this.showLocationMenu = !this.showLocationMenu;
    },
    selectLocation(location) {
      this.selectedLocation = location;
      this.showLocationMenu = false;
      
      // 根据选择的地区重新加载数据
      if (location === this.allRegionsText) {
        // 选择"全部"时不传id，显示所有根据语言筛选的数据
        this.getxuanfeilist();
      } else {
        // 根据地区名称查找对应的地址ID
        const selectedAddress = this.addressList.find(addr => addr.name === location);
        if (selectedAddress && selectedAddress.id) {
          // 传递具体的地址ID进行筛选
          console.log('Selected address ID:', selectedAddress.id);
          this.getxuanfeilist(selectedAddress.id);
        } else {
          // 如果没找到对应的地址，显示全部
          this.getxuanfeilist();
        }
      }
    },
    handleClickOutside(event) {
      const locationSelect = this.$el.querySelector('.location-select');
      if (locationSelect && !locationSelect.contains(event.target)) {
        this.showLocationMenu = false;
      }
    },
  },

  mounted() {
    this.containerHeight = this.$refs.scrollContainer.clientHeight;
    this.startAnimation();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getAddressList()
  },
};
</script>

<style lang="less" scoped>
.tu_list{
  display: flex;
  flex-wrap: wrap;
  padding: 2.5vw;
  background: #1f1c1f;
  padding-top: 100px;
}

.reserve-bg {
  -webkit-text-size-adjust: 100%;
  word-wrap: break-word;
  font: 12px/1.5 "Microsoft YaHei",tahoma,arial,sans-serif;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  background: transparent;
  outline: none;
  font-family: Arial,Microsoft YaHei,sans-serif;
  margin: 0;
  padding: 0;
  border: 0;
  text-decoration: none;
  color: #f3c7a2;
  cursor: pointer;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 50%;
  padding: 0.5rem;
}

.content-bg {
  -webkit-text-size-adjust: 100%;
  word-wrap: break-word;
  font: 12px/1.5 "Microsoft YaHei",tahoma,arial,sans-serif;
  color: #f3c7a2;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-family: Arial,Microsoft YaHei,sans-serif;
  padding: 0;
  min-height: 4.665rem;
  height: auto;
  border-radius: 0.8rem;
  border: 0.25rem solid #766350;
  margin: 0;
  background: #212121;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0.1rem 0.3rem rgba(0,0,0,0.3);
}

.img-container {
  overflow: hidden;
  border-top-left-radius: 0.55rem;
  border-top-right-radius: 0.55rem;
  width: 100%;
}

.item_img {
  width: 102%;
  aspect-ratio: 0.7;
  object-fit: cover;
  display: block;
  margin: -1px -1px 0 -1px;
}

.corner_tag{
  position: absolute;
  right: -42px;
  top: 12px;
  font-size: 0.65rem;
  padding: 2px 40px;
  background: #efcba7;
  color: #8d5825;
  transform: rotate(45deg);
  z-index: 2;
  font-weight: bold;
}

.info_box{
  padding: 0.3rem 0.8rem;
  background: linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.name_box {
  margin-bottom: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.name {
  color: #f3c7a2;
  font-size: 0.9rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 55%;
}

.location {
  font-weight: 400;
  font-size: 16px;
  color: #4a4947;
  padding: 4px 12px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  border-radius: 10px;
  margin-left: 0;
}

.stats {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8rem;
  margin-bottom: 0;
}

.stat_item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.icon {
  width: 1rem;
  height: 1rem;
  opacity: 0.8;
}

.stat_num {
  color: #fff;
  font-size: 0.8rem;
}

.nav_box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  .x_p{
    text-align: center;
    color: #e6b98a;
    img{
      height: 76px;
    }
  }
}
.put_tit{
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before{
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii{
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg,#212121,#313131);
  border: 1px solid #766350;
  .xx_bc{
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    justify-content: space-between;
    padding-top: 10px;
    .top_link{
      padding: 20px 10px;
    }
  }
}
.wuzii_p{
  margin: 26px 20px 16px;
  background: linear-gradient(120deg,#212121,#313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u{
    color: #ccc;
  }
}
.header {
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
}

.header_left {
  display: flex;
  align-items: center;
  width: 150px;
}

.header_center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.header_right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 150px;
  padding-right: 0;
}

.img_c {
  color: #e6b98a;
  font-size: 32px;
  font-weight: bold;
}

.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}

.location-select {
  display: inline-block;
}

.selected-location {
  padding: 8px 12px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: transparent;
  color: #f3c7a2;
  font-size: 26px;
}

.location-icon {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}

.selected-location span:first-child {
  color: #e6b98a;
  font-weight: bold;
  margin-right: 5px;
}

.location-arrow {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  background-size: 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAACH0lEQVRYhe2WS0sbYRSGn14WgongImTbX9BVowR0UUEUcRVKu4vQRUCLbkS7kEqh0EWLLQhaN94qqFhBXfgbuu4P6K8oKhJvHHgHPoYxziUmQr93M/Oe+c45T77LZPDy8vLyeth6ZHT/fv+0yzNgDDgE/rSJ+jnwCtgE/ubLVR7rQQlYAz4CP4BiG+Cs5wrwAdgAeizoAr7UfRk4AgothCuoZ1m+D3jhAi4DFeBcvhc4btFMFtWrV/5cLMsuoOkAqDqQJcXuE7KoHiUHrqoYYUDTHvAWOJW3Kf91T5BF1Q6W9VS999xBYUDTNjABnMj3K9bMPVlQzX75E/XcDg+MAkTHfAo4kx8AtoDuJsB1q9aA/Jl6bUYNvg0QvXbeAXX5If3CrgxwXaoxJF9Xj7XbEhoBmtaBGnAlPwzsA/kUcHnlDstfqfZ6o6S7ANFLs+b4QW3uJJB55Qw6sZpqN1QcQNMqMA5cy9sS7QK5GLk5jQ2W9Vq1VuM0jguI/oYmgQv5EWDnDsicxozIX6jGStymSQBNS8C0c3BGdfo6I8Z26tmofF25S0kaJgU0LQLvgUv5ik5hhzOmQ7GK/KVyFpM2e5oC0PRd12+6vtbeqspvKBZoxslpCWAAad+TC/Jvgu/LENx0WrisgCabwSfAlwgw06wzy6mUZg+G9RWYi4jP6VkmNQPQ9BmYd/y8YpmVdYldfdJyo3svL6//Xl5ebRdwA0IKYvLXgzBPAAAAAElFTkSuQmCC);
}

.location-arrow.arrow-open {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAACA0lEQVRYhe2WTSuEURiGLx+TkB/kN1hI+S7fG1FTlI0SjSyQFKFmodixmCwkUixGTeIv+AHTLKYGNSnRqfvokIx53zNszl3TnPuZc57nes/He4agoKCgoKBYqjODH3OHvmZx6ct3LLW1D9PocX0XgEW1X4FlH0nrfSQB5oGU41OKxZYPwDlg5Zv4in6LpbiAs8Ca44/1sVpTn8iKswdngA3HHwHDar8BfWpvyG9GKRIV0MCtO97M2ijwIj+qN0SvvO1bNWSUJU4Cq0CDfAYYB8pOn7JiGfkGjUnWGnBaS5aQPwVGgOdv+j7rt1P5hMZO1wpwEth2tsUZMAA8/TDmSX3O5BuVY9I34ASwZ28e4ALorwDnQvZrDMqxp5xeAM2GTzv+EugxN+RvCkiPGnPpxNLKHQtwTIlsv3Ogu0o4F7JbOWzttGpEAjSncMc5EGaJBoFSBDirknLY5U6oxni1gOb0bQHN8lfAEFCMAWdVVK4r+WbVGvktoHnCXaBVPqtYwQOcVUE5s/KtqjlYCdC8+feBFvmcNnfeI5xVXrlz8i2q3et2cgG7APPPtUn+TrFawLmQXaqFah8q9glwSteShbsFOmoM50J2qKaFzIjpA9A8wbXaZso7Pe+5Siqopl3uG+Ae59q601E3J+nkj2buq/K6As278gB4+AeGoKCgoKCqBLwD8cxt4VpkGhYAAAAASUVORK5CYII=);
}

.location-menu {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  background-color: #1f1c1f;
  border-top: 1px solid #766350;
  border-bottom: 1px solid #766350;
  z-index: 9;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  width: 100%;
}

.location-menu.location-menu-open {
  max-height: 500px;
}

.location-item-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.location-item {
  padding: 12px 20px;
  margin: 8px;
  cursor: pointer;
  color: #f3c7a2;
  font-size: 20px;
  text-align: center;
  border: 1px solid #766350;
  border-radius: 30px;
  min-width: 100px;
  background-color: #212121;
}

.location-item:hover {
  background-color: #313131;
}

.location-item.active {
  color: #e6b98a;
  font-weight: bold;
  background-color: #2a2a2a;
}

.tu_list {
  display: flex;
  flex-wrap: wrap;
  padding: 2.5vw;
  background: #1f1c1f;
  padding-top: 100px;
}

.register-btn {
  color: #f3c7a2;
  cursor: pointer;
  font-size: 18px;
}

.register-btn:hover {
  color: #e6b98a;
}
</style>
